// 动画
AOS.init({
    easing: 'ease',
    duration: 800,
    once:true,
});

var announcementSwiper = new Swiper(".announcement_swiper", {
  navigation: {
    nextEl: ".announcement_swiper .swiper-button-next",
    prevEl: ".announcement_swiper .swiper-button-prev",
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  speed:600,
});


// header 鼠标移入 add white bg
$("header ul li.site-nav__item").mouseenter(function(){
    let isOpen = $(this).children("details").attr("open")
    if(isOpen){
      $("header").addClass("bgWhite")
    }
})
$("header ul li.site-nav__item").mouseleave(function(){
      $("header").removeClass("bgWhite")
})
// homePage
let setDirection = ''
if(window.screen.width > 1024){
    setDirection = 'vertical'
}else{
    setDirection = 'horizontal'
}
var swiper1 = new Swiper(".bannerSwiper", {
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    direction: setDirection,
    autoplay: {
        delay: 7000,
    },
    navigation: {
        nextEl: ".bannerSwiperNext",
        prevEl: ".bannerSwiperPrev",
    },
    pagination: {
        el: ".bannerSwpPagination",
        clickable: true,
    },
});

var swiper = new Swiper(".homeSwiper1", {
  loop: true,
  spaceBetween: 10,
  slidesPerView: 1,
  watchSlidesProgress: true,
  autoplay: {
    delay: 3000,
  },
});
let swiper2Slide = ''
if(window.screen.width > 1024){
    swiper2Slide = 7
}else{
    swiper2Slide = 3
}
var swiper2 = new Swiper(".homeSwiper2", {
  loop: true,
  slidesPerView: swiper2Slide,
  spaceBetween: 10,
  autoplay: {
    delay: 3000,
  },
  navigation: {
    nextEl: ".homeSwiper1Next",
    prevEl: ".homeSwiper1Prev",
  },
  centeredSlides: true,
  thumbs: {
    swiper: swiper,
  },
});
let swiper3Slide = ''
if(window.screen.width > 1024){
    swiper3Slide = 4.2
}else{
    swiper3Slide = 1
}
var swiper3 = new Swiper(".homeSwiper3", {
    slidesPerView: swiper3Slide,
    loop: true,
    centeredSlides: true,
    spaceBetween: 10,
    autoplay: {
        delay: 3000,
    },
    navigation: {
        nextEl: ".homeSwiper3Next",
        prevEl: ".homeSwiper3Prev",
    },
});
// dogCameraPage
$(function(){
      // table
      $(".dogCameraModel10_main ul li").click(function(){
          let index = $(this).index();
          $(this).addClass("active").siblings().removeClass("active");
          $(".dogCameraModel10_main .content section").hide();
          $(".dogCameraModel10_main .content section").eq(index).show();
      })
      // toggle
      $(".leftsidebar_box dd").hide();
      $(".leftsidebar_box dt").click(function(){
          $(this).parent().find('dd').removeClass("menu_chioce");
          $('.dogCameraModel10_main .content .leftsidebar_box dt .iconfont').removeClass('iconTransform')
          $(".menu_chioce").slideUp();
          $(this).parent().find('dd').slideToggle(function(){
              if($(this).parent().find('dd').is(':visible')){
                  $(this).parent().find('dt .iconfont').addClass('iconTransform')
              }else{
                  $(this).parent().find('dt .iconfont').removeClass('iconTransform')
              }
          });
          $(this).parent().find('dd').addClass("menu_chioce");
      });
  })
  let swiper4Slide = ''
  if(window.screen.width > 1024){
      swiper4Slide = 3
  }else{
      swiper4Slide = 1.5
  }
  var swiper4 = new Swiper(".dogCameraSwiper", {
      slidesPerView: swiper4Slide,
      loop: true,
      centeredSlides: true,
      spaceBetween: 0,
      autoplay: {
          delay: 3000,
      },
      navigation: {
          nextEl: ".cameraSwiperNext",
          prevEl: ".cameraSwiperPrev",
      },
  });
// largePetFeeder-page
// 点击打开关闭视频
$(".petFeederModel1 img:nth-child(2)").click(function(){
  $(".largeVideoModel").css("display","flex")
})
$(".largeVideoBox p").click(function(){
    $(".largeVideoModel").hide()
})

// scroll to top
var btn = document.getElementById('myBtn');

window.onscroll = function() {
    scrollFunction();
};

function scrollFunction() {
    if (document.body.scrollTop > 3000 || document.documentElement.scrollTop > 3000) {
        btn.style.display = "block";
    } else {
        btn.style.display = "none";
    }
} 

btn.addEventListener("click", function() {
    var position = document.documentElement.scrollTop || document.body.scrollTop;
    var interval = setInterval(function() {
        if (position > 0) {
            window.scrollBy(0, -50);
            position -= 50;
        } else {
            clearInterval(interval);
        }
    }, 10);
});
// Xmas-page
let swiper5Slide = ''
if(window.screen.width > 1024){
    swiper5Slide = 3
}else{
    swiper5Slide = 1
}
setTimeout(()=>{
  var swiper5 = new Swiper(".xmasSwiper", {
      slidesPerView: swiper5Slide,
      loop: true,
      centeredSlides: true,
      spaceBetween: 0,
      autoplay: {
          delay: 3000,
      },
      navigation: {
          nextEl: ".xmasSwiperNext",
          prevEl: ".xmasSwiperPrev",
      },
  });
},800)

// affiliate-page
$(".affiliationSection3 ul li .faq_answer").hide()
$(".affiliationSection3 ul li .faq_ask").click(function(){
    $(this).siblings().toggle(200,function(){
        if($(this).is(':visible')){
            $(this).siblings().addClass("arrow-up").parent().siblings().find(".faq_ask").removeClass("arrow-up")
            $(this).parent().siblings().find(".faq_answer").hide(200)
        }else{
            $(this).siblings().removeClass("arrow-up")
        }
    })
})

// shockCollar product
var swiper6 = new Swiper(".shockCollar2Swiper", {
    centeredSlides: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    loop:true,
    speed:500,
    effect: 'fade',
});
$(function(){
    $(".shockCollar6_title span").click(function(){
        let index = $(this).index();
        $(this).addClass("active").siblings().removeClass("active");
        $(".shockCollar6_box").hide();
        if (window.screen.width > 1024) {
            $(".shockCollar6_box").eq(index).css("display","flex");
        } else {
            $(".shockCollar6_box").eq(index).css("display","block");
        }
    })
})

// mothersDay
$(window).load(function() {
    $('.homeSection3_imgGroup').liMarquee();
});
var swiper7 = new Swiper(".mothersDay1Swiper", {
    autoplay: {
      delay: 3000,
    },
    loop:true,
    speed:500,
    effect: 'fade',
    pagination: {
      el: ".mothersDaySwiperPage",
      clickable: true,
    },
});

// vacuumPetFeeder
$('.counter').countUp({
    delay: 10,
    time: 3000
});
$(function(){
    $(".vacuumPetFeeder11 ul li").hover(function(){
        let index = $(this).index();
        $(this).addClass("active").siblings().removeClass("active");
        $(".vacuumPetFeeder11_content img").hide();
        $(".vacuumPetFeeder11_content img").eq(index).show();
    })
})
$(".vacuumPetFeeder14 span").click(function(){
    $(".vacuumPetFeeder14_clickImg").css("display","flex")
})
$(".vacuumPetFeeder14_clickCenter p").click(function(){
    $(".vacuumPetFeeder14_clickImg").hide()
})
$(".leftsidebar_box15 dt").click(function() {
    $(this).parent().find('dd').removeClass("menu_chioce");
    $(".menu_chioce").slideUp();
    $(this).parent().find('dd').slideToggle(function() {
        if ($(this).parent().find('dd').is(':visible')) {
            $(this).parent().addClass('active').siblings().removeClass('active')
        }else{
            $(".leftsidebar_box15 dl").removeClass('active')
        }
    });
    $(this).parent().find('dd').addClass("menu_chioce");
});
var swiper8 = new Swiper(".vacuumPetFeeder11_swiper", {
  spaceBetween: 30,
  pagination: {
    el: ".vacuumPetFeeder11_swiper .swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  loop: true,
});

// vacuumPetFeeder product youtube video autoplay
var videoDiv = document.createElement('div');
videoDiv.id = 'youtube-video';
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var player;
function onYouTubeIframeAPIReady() {
  player = new YT.Player('youtube-video', {
    width: 640,
    height: 390,
    videoId: 'cxcsQzHu-5M?si=5rRoUxcKWDJugXm8',
    playerVars: {
      'autoplay': 1,
      'controls': 0,
      'rel': 0
    },
    events: {
      'onReady': onPlayerReady,
    }
  });
}
function onPlayerReady(event) {
  event.target.playVideo();
}
$(".vacuumPetFeeder2 img").click(function(){
    $(this).hide()
    $(".vacuumPetFeeder2").append(videoDiv);
    onYouTubeIframeAPIReady()
})

// product discount code
$("#addCopyButton").click(function() {
    var info = $("#infoDiv").text();
    var tempTextArea = $("<textarea>");
    tempTextArea.val(info);
    $("body").append(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    tempTextArea.remove();
    $("#addCopyButton").text("Copied!")
    setTimeout(()=>{
      $("#addCopyButton").text("Copy Code")
    },2000)
});
let discountCopySection = $(".discountCopy")
let addExplain = $(".addExplain")
$(".product-block--price").after(discountCopySection)
$(".discountCopy").show().after(addExplain)

// xmas2024-navBar 倒计时
// document.addEventListener('DOMContentLoaded', function() {
//     var d, h, m, s;
//     // 设置结束时间
//     let endDate = new Date('2025/1/1 16:00:00');
//     function updateCountdown() {
//         const now = new Date();
//         now.setUTCHours(now.getUTCHours() + (now.getTimezoneOffset() + 8 * 60) / 60);
//         // 获取时间差 = 结束时间戳 - 开始时间戳
//         let startTime = now.getTime()
//         let endTime = endDate.getTime()
//         // 将时间差转换为小时、分钟和秒
//         if (endTime >= startTime) {
//             timeArr(endTime - startTime)
//                   $(".announcement__text strong").text(`XMAS Sale Countdown -- ${d}Days ${h}: ${m}: ${s} 🎅`);
//         }
//     }
//     function timeArr(timeLeft){
//         d = Math.floor(timeLeft/1000/60/60/24);
//         h = Math.floor(timeLeft/1000/60/60%24);
//         m = Math.floor(timeLeft/1000/60%60);
//         s = Math.floor(timeLeft/1000%60);
//     }
//     setInterval(updateCountdown, 1000);
// });

// product page coupon banner promotion
const copyBtn = document.getElementById('copyCodeBtn');
const codeContent = document.getElementById('coupon-code');

copyBtn.addEventListener('click', function() {
    const couponCode = codeContent.textContent;
    navigator.clipboard.writeText(couponCode).then(() => {
        this.textContent = "Copied";
        this.classList.add('copied');
        
        setTimeout(() => {
            this.textContent = "Copy";
            this.classList.remove('copied');
        }, 3000);
    }).catch(err => {
        console.error('Failed to copy:', err);
    });
});
// product page key features list show less show more
document.addEventListener('DOMContentLoaded', function() {
    const content = document.getElementById('key-features-content');
    const toggleBtn = document.getElementById('key-features-toggleBtn');
    const toggleText = document.getElementById('toggleText');
    
    checkContentHeight();  
    window.addEventListener('resize', checkContentHeight);
    
    toggleBtn.addEventListener('click', function() {
        content.classList.toggle('collapsed');
        
        if (content.classList.contains('collapsed')) {
            toggleText.textContent = 'See More';
            content.classList.remove("expanded");
        } else {
            toggleText.textContent = 'See Less';
            content.classList.add("expanded");
        }
    });
    
    function checkContentHeight() {
        const fullHeight = content.scrollHeight;
        const collapsedHeight = parseInt(window.getComputedStyle(content).maxHeight);
      
        if (fullHeight <= collapsedHeight) {
            toggleBtn.style.display = 'none';
        } else {
            toggleBtn.style.display = 'flex';
        }
    }
});
//product page installment collapsed expand
document.addEventListener('DOMContentLoaded', function() {
    const toggleHeader = document.querySelector('.installment-header');
    const toggleContainer = document.querySelector('.payment-installment-container');
    const toggleContent = document.querySelector('.installment-message');
    
    toggleHeader.addEventListener('click', function() {
        const isCollapsed = toggleContainer.classList.toggle('collapsed');
        
        if (isCollapsed) {
            toggleContent.style.height = '0';
        } else {
            toggleContent.style.height = 'auto';
        }
    });

});